import React, { useEffect, useState } from "react";
import { DatePicker, Button } from '../../../common/commonIndex';

const StepDOB = ({ handleNextEvent, formData, getPersonalInfo, updatePersonalInfo, setFormValues, handleSetDateOfBirth }) => {
    const [birthDate, setBirthDate] = useState({
        day: null,
        month: null,
        year: null
    })
    useEffect(() => {
        getPersonalInfo();
    }, [])

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.day) {
            formData.day = 1;
        }
        if (!formData.month) {
            formData.day = 1;
        }
        if (!formData.year) {
            formData.year = 1990;
        }
        
        handleSetDateOfBirth(birthDate);
        updatePersonalInfo(formData);
        // handleNextEvent(8);
    };
    // const isValid = formData.day && formData.month && formData.year;
    return (
        <div className="date-of-birth-container">
            <h2 className="title">What is your date of birth?</h2>
            <DatePicker formData={formData} setBirthDate={setBirthDate} isPersonalInfo={true} setFormValues={setFormValues} />

            <Button
                btnClass={'btn-primary'}
                btnType={'submit'}
                btnName={'Submit'}
                onClick={handleSubmit}
                isDisabled={true}
            />
        </div>
    );
}

export default StepDOB;